import _ from "lodash";
import checkAvsStatusError from "~/assets/utils/Avs/checkAvsStatusError";
import getAvsParams from "~/assets/utils/getAvsParams";
import { getStore } from "~/assets/utils/storeAccessor";
import updateDetails from "~/assets/utils/updateDetails";
import { AVSStatus } from "~/entities/AVS";
import { Details } from "~/entities/Details";

// import checkIfDetailUpdated from '~/assets/utils/checkIfDetailUpdated';

export interface IChangedFlags {
  isAddress1Changed: boolean;
  isAddress2Changed: boolean;
  isCityChanged: boolean;
  isCountryChanged: boolean;
  isPostalChanged: boolean;
  isStateChanged: boolean;
}

export default async function (details: Details): Promise<{
  stageDetails: Details;
  updatedDetails: Details;
  changedFlags: IChangedFlags;
}> {
  // call avs endpoint to see if it can add to the details on every stage from an to
  // let needsAVSModal = false;
  let changedFlags: IChangedFlags = {
    isAddress1Changed: false,
    isAddress2Changed: false,
    isCityChanged: false,
    isCountryChanged: false,
    isPostalChanged: false,
    isStateChanged: false,
  };
  let stageDetails: Details = _.cloneDeep(details);
  let updatedDetails: Details = _.cloneDeep(details);
  let error: any;
  const store = getStore();
  const NeedsAVSCheck = !stageDetails?.passedAvs && !stageDetails?.avsChecked;
  if (
    !stageDetails.address1 ||
    !stageDetails.streetAddress ||
    !stageDetails.city ||
    !stageDetails.postalCode ||
    !stageDetails.country ||
    !stageDetails.state
  ) {
    return {
      stageDetails,
      updatedDetails,
      changedFlags,
    };
  }
  if (NeedsAVSCheck) {
    const avsCheck = await store.dispatch(
      "ship/requestAVSCheck",
      getAvsParams(stageDetails)
    );
    // needs to add to the details the residential mark if the avs return true on that
    if (avsCheck) {
      const updatedDetailFrom = _.cloneDeep(updatedDetails);
      updatedDetails = updateDetails(avsCheck, updatedDetailFrom);
      if (avsCheck.isChanged) {
        // needsAVSModal = true;
        changedFlags = avsCheck.changedFlags;
      } else if (typeof avsCheck.passedAvs === "boolean") {
        // if the AVS not need shown the modal, stageDetails is updated with the AVS result
        stageDetails = updateDetails(avsCheck, stageDetails);
        if (avsCheck.passedAvs) {
          stageDetails.avsStatus.status = AVSStatus.success;
        } else {
          stageDetails.avsStatus.status = AVSStatus.failed;
          stageDetails.avsStatus.subStatus = checkAvsStatusError(avsCheck);
          stageDetails.avsProblem = true;
          error = avsCheck.errorMessage;
        }
      }
    }
  }
  // stageDetails: the details that are going to be used to check if the avs is needed
  // updatedDetails: the details updated with the avs result, if the AVS modal is needed
  // needsAVSModal: if the AVS modal is needed
  const avsObject: {
    stageDetails: Details;
    updatedDetails: Details;
    changedFlags: IChangedFlags;
    error?: any;
  } = {
    stageDetails,
    updatedDetails,
    changedFlags,
    error,
  };
  return avsObject;
}
